// src/components/admin/AdminDashboardSection.jsx
import React from "react";
import { Users, Shield, Calculator } from "lucide-react";

const AdminDashboardSection = ({
  statsLoading,
  totalUsers,
  totalAdmins,
  totalAccountants,
}) => {
  const cards = [
    {
      label: "کل کاربران",
      value: statsLoading ? "..." : totalUsers,
      icon: Users,
      accent: "from-sky-500 to-indigo-500",
      badge: "کاربران ثبت‌شده",
    },
    {
      label: "مدیران",
      value: statsLoading ? "..." : totalAdmins,
      icon: Shield,
      accent: "from-violet-500 to-purple-600",
      badge: "سطح دسترسی بالا",
    },
    {
      label: "حسابداران",
      value: statsLoading ? "..." : totalAccountants,
      icon: Calculator,
      accent: "from-emerald-500 to-teal-500",
      badge: "امور مالی",
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 lg:gap-6" dir="rtl">
      {cards.map(({ label, value, icon: Icon, accent, badge }) => (
        <div
          key={label}
          className="relative overflow-hidden rounded-2xl bg-white/95 backdrop-blur border border-slate-200 shadow-sm hover:shadow-md hover:-translate-y-0.5 transition-all"
        >
          <div className="absolute -left-10 -top-10 w-28 h-28 rounded-full bg-gradient-to-br opacity-10 pointer-events-none blur-2xl bg-sky-500" />
          <div className="p-4 sm:p-5 flex flex-col gap-3">
            <div className="flex items-center justify-between gap-3">
              <div className="flex flex-col items-end">
                <span className="text-xs text-slate-500">{label}</span>
                <span className="mt-1 text-2xl font-extrabold text-slate-900 tabular-nums">
                  {value}
                </span>
              </div>
              <div
                className={`w-10 h-10 rounded-2xl bg-gradient-to-br ${accent} flex items-center justify-center text-white shadow`}
              >
                <Icon size={22} />
              </div>
            </div>
            <div className="flex justify-start">
              <span className="inline-flex items-center rounded-full bg-slate-50 px-2.5 py-1 text-[11px] font-medium text-slate-500 border border-slate-100">
                {badge}
              </span>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default AdminDashboardSection;
